import React, { useState, useRef } from "react";
import _ from "lodash";
import { EuiText, EuiButton, EuiButtonEmpty, EuiFlexItem } from "@elastic/eui";
import Moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import * as S from "./mentionStyle.js";
import TripSection from "../../trips/components/shared/TripSection";
import CommentsForm from "./CommentForm";
import userIcone from "../../../assets/images/user_icone.png";
import { commentsSelectors, getAllComments, addingLastComment } from "./commentSlice";
import { adminSelectors } from "./slice";

let listOfComments = [];
function CommentsView({ tripId, commentableType }) {
    const dispatch = useDispatch();
    const allAdmins = useSelector(adminSelectors());
    const comments = useSelector(commentsSelectors());
    const pageCount = comments.pageIndex > 0 ? comments.pageIndex : comments.pagingObject.pageCount;

    let aAdmins = [];
    if (allAdmins || allAdmins != undefined) {
        aAdmins = Object.values(allAdmins);
    }
    if (comments || comments.comments.length > 0) {
        listOfComments = comments;
    } else if (listOfComments && listOfComments.length > 0) {
        listOfComments = arrayOfcomments;
    } else {
        listOfComments = [];
    }

    const [isShow, setIsShow] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const userId = localStorage.getItem("userId").replace(/\"/g, "");
    let arrayOfcomments;
    let currentAdmin;
    let selectedUserName;
    let commentCreator;
    let commentCreatorName;
    let currentAdminName;

    if (comments && comments.comments && comments.comments.length > 0) {
        arrayOfcomments = listOfComments.comments.map((comment) => {
            let change = comment.attributes.content;
            let mentionLinks = change;
            commentCreator = aAdmins.find(
                (creator) => creator.id === comment.attributes.adminUserId
            );
            if (!commentCreator) {
                return false;
            }
            commentCreatorName = `${commentCreator.attributes.firstName} ${commentCreator.attributes.lastName}`;

            currentAdmin = aAdmins.find((y) => y.id == userId);
            currentAdminName = `${currentAdmin.attributes.firstName} ${currentAdmin.attributes.lastName}`;
            comment.attributes.mentionedAdminUserIds.forEach((meUser) => {
                const selectedUSer = aAdmins.find((x) => x.id === meUser);
                if (
                    selectedUSer &&
                    selectedUSer.attributes &&
                    selectedUSer.attributes.firstName &&
                    selectedUSer.attributes.lastName
                ) {
                    selectedUserName = `${selectedUSer.attributes.firstName}_${selectedUSer.attributes.lastName}`;
                } else {
                    selectedUserName = selectedUSer.attributes.email;
                }

                mentionLinks = change.replaceAll(`@__${meUser}`, ` @${selectedUserName} `);
                change = mentionLinks;
                mentionLinks = mentionLinks.split(" ");
                // Created: after split array we need to delete all empty space index and return only text
                const mentionItemsOnly = mentionLinks.filter((text) => text !== "" || text === "@");
                for (let i = 0; i < mentionItemsOnly.length; i += 1) {
                    if (mentionItemsOnly[i].match(/[\@]/)) {
                        mentionItemsOnly[i] = (
                            <a href>
                                <b> {mentionItemsOnly[i]} &nbsp; </b>
                            </a>
                        );
                    } else {
                        mentionItemsOnly[i] = (
                            <text className="match">{mentionItemsOnly[i]} &nbsp;</text>
                        );
                    }
                }
                mentionLinks = mentionItemsOnly;
                return <div>{mentionLinks} </div>;
            });

            const date = Moment(comment.attributes.createdAt).format(
                "dddd, MMMM Do YYYY, h:mm:ss a"
            );

            return (
                <S.StyledComment
                    key={comment.id}
                    username={commentCreatorName}
                    event="added a comment"
                    timestamp={date}
                    timelineIcon={userIcone}
                >
                    <EuiText size="s">{mentionLinks}</EuiText>
                    <EuiFlexItem grow={false}>
                        <EuiButtonEmpty
                            className="styled-reply-button"
                            iconType="returnKey"
                            onClick={() => scrollToAddComment()}
                        >
                            comment
                        </EuiButtonEmpty>
                    </EuiFlexItem>
                </S.StyledComment>
            );
        });
    } else {
    }

    const handelCommentBtns = async ({ isShow, itemComment }) => {
        dispatch(addingLastComment([...listOfComments.comments, ...itemComment]));
        setIsShow(isShow);
        setIsShow(!isShow);
    };

    const getPrevsComments = async (size) => {
        await setIsLoading(true);
        await dispatch(getAllComments(tripId, size, pageCount));
        setIsLoading(false);
    };

    const scrollToTextArea = useRef(null);
    const scrollToAddComment = () => {
        setIsShow(true);
        scrollToTextArea.current.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <div>
            <div>
                <TripSection
                    headerTitle="Comments"
                    headerIconType="editorComment"
                    isCommenSection
                >
                    {arrayOfcomments && arrayOfcomments.length > 0 ? (
                        <>
                            {pageCount > 2 && (
                                <EuiFlexItem grow={false}>
                                    <EuiButtonEmpty
                                        href=""
                                        onClick={() => getPrevsComments(4)}
                                        isLoading={isLoading}
                                    >
                                        Load Previous Comments&hellip;
                                    </EuiButtonEmpty>
                                </EuiFlexItem>
                            )}
                            <>
                                {arrayOfcomments}
                                <div ref={scrollToTextArea} />
                            </>
                            {isShow ? (
                                <CommentsForm
                                    tripId={tripId}
                                    commentableType={commentableType}
                                    handelCommentBtn={handelCommentBtns}
                                    userName={currentAdminName}
                                    scrollToTextArea={scrollToTextArea}
                                />
                            ) : (
                                <EuiButton onClick={() => setIsShow(!isShow)}>
                                    Add new comment
                                </EuiButton>
                            )}
                        </>
                    ) : (
                        [
                            isShow ? (
                                <CommentsForm
                                    tripId={tripId}
                                    commentableType={commentableType}
                                    handelCommentBtn={handelCommentBtns}
                                    scrollToTextArea={scrollToTextArea}
                                />
                            ) : (
                                <EuiButton onClick={() => setIsShow(!isShow)}>
                                    Add new comment
                                </EuiButton>
                            ),
                        ]
                    )}
                </TripSection>
            </div>
        </div>
    );
}

export default CommentsView;
